import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { MONTHLY_CLAIM_FORM_FORM_NAME } from 'Common/FormEnum';
import { MonthlyClaimFormFieldEnum as Fields } from 'Common/FieldEnum';
import { DatePickerField } from 'Common/SemanticWrapper';

class MonthlyClaimFormFormContainer extends Component {
  render() {
    const { loading } = this.props;
    return (
      <Fragment>
        <Form name={MONTHLY_CLAIM_FORM_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Date'}
                  name={Fields.FromDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                  maxDate={moment()}
                  disabled={loading}
                  dateFormat={'MM/YYYY'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!moment(values[Fields.FromDate], 'MM/YYYY').isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }
  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(MONTHLY_CLAIM_FORM_FORM_NAME)(state),
    loading: false,
  };
};

const MonthlyClaimFormForm = reduxForm({
  form: MONTHLY_CLAIM_FORM_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps)(MonthlyClaimFormFormContainer)));

export { MonthlyClaimFormForm };



// WEBPACK FOOTER //
// ./src/pages/monthlyclaimform/components/MonthlyClaimFormForm.js